import styled from 'styled-components';

const Center = styled.div`
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
`;

export default Center;
